'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PillItem = require('./PillItem');

Object.defineProperty(exports, 'PillItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PillItem).default;
  }
});

var _PillList = require('./PillList');

Object.defineProperty(exports, 'PillList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PillList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/pill/index.js
// module id = 595
// module chunks = 0